import { useMutation } from '@tanstack/react-query';

import { calendarApi } from '../api';

interface UseSubscribeOutlookCalendarWatchParams {
  calendarIds: string[];
  userId: string;
}

export function useSubscribeOutlookCalendarWatch() {
  const subscribeOutlookWatchMutation = useMutation({
    mutationFn: ({ calendarIds, userId }: UseSubscribeOutlookCalendarWatchParams) => {
      return calendarApi.subscribeOutlookCalendarWatch({ calendarIds, userId });
    },
  });

  return {
    subscribeOutlookCalendarWatch: subscribeOutlookWatchMutation.mutateAsync,
    ...subscribeOutlookWatchMutation,
  };
}
